function SharePage() {
  return (
    <div className='pt-16'>
      <h2>Share</h2>
    </div>
  );
}

export default SharePage;
